import { Container, MainText, SecondaryText, IconContainer } from './Styles'
import { ReactComponent as EditIcon } from 'assets/images/EditIcon.svg'
import { ReactComponent as WeightArrowRight } from 'assets/images/WeightArrowRight.svg'

interface Props {
  from: string
  to: string
  fullDate: string
  handleClickEdit: () => void
}

const FormResponse = ({ from, to, fullDate, handleClickEdit }: Props) => {
  return (
    <Container>
      <div>
        <MainText>
          {from} <WeightArrowRight /> {to}
        </MainText>
        <SecondaryText>{fullDate}</SecondaryText>
      </div>
      <IconContainer onClick={handleClickEdit}>
        <EditIcon />
      </IconContainer>
    </Container>
  )
}

export default FormResponse
